import { socket } from '../core/socket.js';
import { state } from '../core/state.js';
import { t, i18n } from '../core/i18n.js';
import { popToast } from '../utils/alerts.js';
import { chargerSphereEmojis } from '../core/customEmojis.js';
import { _getInputText, _clearInput } from './chatInput.js';

let _webhookSalonId = null;
let isTyping = false;
let typingTimeout;
let lastTypingSent = 0;

// ── Messages éphémères ────────────────────────────────────────────────────────
let _ephemereApres = null; // secondes, ou null si non armé

export function getEphemereApres() { return _ephemereApres; }

export function armerEphemere(secondes) {
    _ephemereApres = secondes;
    const labels = { 60: '1 min', 600: '10 min', 3600: '1 h', 86400: '24 h', 604800: '7 j' };
    const label = labels[secondes] || `${secondes}s`;
    const armed = document.getElementById('ephemere-armed');
    const armedLabel = document.getElementById('ephemere-armed-label');
    const picker = document.getElementById('ephemere-picker');
    if (armedLabel) armedLabel.textContent = `⏱ ${label}`;
    if (armed) armed.style.display = 'flex';
    if (picker) picker.style.display = 'none';
}

export function desarmerEphemere() {
    _ephemereApres = null;
    const armed = document.getElementById('ephemere-armed');
    const picker = document.getElementById('ephemere-picker');
    if (armed) armed.style.display = 'none';
    if (picker) picker.style.display = 'none';
}

export function ouvrirEphemere() {
    const picker = document.getElementById('ephemere-picker');
    if (!picker) return;
    picker.style.display = picker.style.display === 'none' ? 'flex' : 'none';
}

export function ouvrirChatPrive(pseudo) {
    if (!pseudo) return;

    if (typeof window.sauvegarderDernierVu === 'function') window.sauvegarderDernierVu();

    window.destinataireID = pseudo; state.destinataireID = pseudo;
    window.salonActuelID = null; state.salonActuelID = null;

    socket.emit('marquer-lu', { expediteur: pseudo, destinataire: window.monPseudo });
    if (state.notifications) state.notifications[pseudo] = 0;
    
    if (typeof window.gererBulleMP === 'function') window.gererBulleMP(pseudo);
    if (typeof window.supprimerBulleSiLue === 'function') window.supprimerBulleSiLue(pseudo);
    if (typeof window.basculerAffichage === 'function') window.basculerAffichage('chat');

    const channelsCol = document.getElementById('channels-column');
    const inputArea = document.querySelector('.input-area');
    const messagesUl = document.getElementById('messages');

    if (channelsCol) channelsCol.style.display = 'none';
    if (inputArea) inputArea.style.left = "95px";
    if (messagesUl) messagesUl.innerHTML = '';
    
    if (typeof window.majPushChannels === 'function') window.majPushChannels();
    if (typeof window.resetSearch === 'function') window.resetSearch();

    setTimeout(() => {
        socket.emit('get-private-history', { avec: pseudo });
    }, 200);

    if (typeof window.updateChatHeader === 'function') window.updateChatHeader(pseudo);
    if (typeof window.majVisibiliteRecherche === 'function') window.majVisibiliteRecherche(true);
    if (typeof window.majIndicateurE2EE === 'function') window.majIndicateurE2EE(pseudo);

    socket.emit('demander-liste-maj');

    localStorage.setItem('derniereVue', JSON.stringify({ 
        vue: 'mp', 
        data: { pseudo: pseudo } 
    }));
}

export function rejoindreSphere(sphereId, nomSphere) {
    window.sphereActuelleID = sphereId; state.sphereActuelleID = sphereId;
    window.salonActuelID = null; state.salonActuelID = null;
    window.destinataireID = null; state.destinataireID = null;
    window._pendingAutoNavSphere = true;

    // Garantit que derniereVue pointe sur le vrai sphereId (pas un salonId parasite).
    try {
        const sav = JSON.parse(localStorage.getItem('derniereVue') || 'null');
        if (sav && sav.vue === 'sphere' && sav.data && String(sav.data.id) !== String(sphereId)) {
            sav.data.id = sphereId;
            localStorage.setItem('derniereVue', JSON.stringify(sav));
        }
    } catch(e) {}

    if (typeof window.basculerAffichage === 'function') window.basculerAffichage('chat');
    
    const channels = document.getElementById('channels-column');
    const messagesUl = document.getElementById('messages');
    const inputArea = document.querySelector('.input-area');
    const titreSidebar = document.getElementById('current-sphere-name'); 

    const nomAffiche = nomSphere || window.nomSphereActuelle || "Dimension Inconnue";
    if (nomSphere) window.nomSphereActuelle = nomSphere;
    
    const welcomeMsgs = i18n.tArray ? i18n.tArray('welcome.msgs') : [];
    const msgAleatoire = welcomeMsgs[Math.floor(Math.random() * welcomeMsgs.length)] || '';
    
    if (titreSidebar) titreSidebar.innerText = nomAffiche; 
    if (inputArea) inputArea.style.setProperty('display', 'none', 'important');
    
    if (channels) {
        channels.style.display = 'block';
        channels.classList.add('open');
        channels.classList.remove('closed');
    }
    if (typeof window.majPushChannels === 'function') window.majPushChannels();

    if (messagesUl) {
        messagesUl.innerHTML = `
            <div class="welcome-container">
                <div class="welcome-icon">🛰️</div>
                <h2 class="welcome-title">${t('welcome.access', {name: nomAffiche})}</h2>
                <p class="welcome-text">${t('welcome.stabilizing')}</p>
                <p class="welcome-text">${msgAleatoire}</p>
                <div class="welcome-hint">${t('welcome.select_channel')}</div>
            </div>
        `;
    }

    socket.emit('demander-salons', sphereId);
    socket.emit('demander-membres-sphere', sphereId);
    chargerSphereEmojis(sphereId);
}

export function nettoyerHeaderGlobal() {
    const header = document.getElementById('chat-header');
    const btnCall = document.getElementById('btn-call-mp');

    if (header) {
        header.innerHTML = t('header.station');
        header.classList.remove('header-private');
        header.classList.add('header-general');
    }

    if (btnCall) btnCall.style.display = 'none';
    if (typeof window.majVisibiliteRecherche === 'function') window.majVisibiliteRecherche(false);

    window.destinataireID = null; state.destinataireID = null;
}

export async function envoyerMPE2EE(texteConverti, opts = {}) {
    const replyTo = opts.replyTo || null;
    const logicalId = crypto.randomUUID();
    const buf = window._rekeyBuffer = window._rekeyBuffer || new Map();
    buf.set(logicalId, { texte: texteConverti, destinataire: window.destinataireID });
    if (buf.size > 60) buf.delete(buf.keys().next().value);

    try {
        const result = await window.ChaosMPCrypto.chiffrerPourPair(texteConverti, window.destinataireID, socket);
        if (!result) return 'fallback';

        const myDeviceId = await window.ChaosKeystore.getMeta('device_id');
        let sbk_backup = null;
        if (window.ChaosSessionBackup) {
            const sbk = await window.ChaosKeystore.getMeta('session_backup_key');
            if (sbk) {
                const encrypted_content = await window.ChaosSessionBackup.chiffrerAvecSBK(texteConverti, sbk);
                sbk_backup = { encrypted_content };
            } else {
                console.warn('[E2EE] SBK absente — la sync cross-device ne fonctionnera pas. Entre ton PIN à la prochaine connexion.');
            }
        }
        socket.emit('chat-mp-e2ee', {
            destinataire: window.destinataireID,
            envelopes: result.envelopes,
            device_expediteur: myDeviceId,
            message_logical_id: logicalId,
            sbk_backup
        });
        if (window.ChaosSessionBackup) {
            for (const env of result.envelopes) {
                window.ChaosSessionBackup.planifierSauvegarde(env.device_destinataire, window.destinataireID, socket);
            }
        }
        const tempId = 'local-' + Date.now();
        if (typeof window.ajouterMessageAuDOM === 'function') {
            window.ajouterMessageAuDOM({
                id: tempId,
                auteur: window.monPseudo,
                texte: texteConverti,
                destinataire: window.destinataireID,
                date_envoi: new Date(),
                couleur_bdd: window.maCouleur,
                badge: state.utilisateurs[window.monPseudo]?.badge || null,
                replyTo: replyTo,
                message_logical_id: logicalId,
                e2ee: true
            }, { playEffect: true });
        }
        await window.ChaosKeystore.saveMessage({
            id: tempId,
            auteur: window.monPseudo,
            interlocuteur: window.destinataireID,
            texte: texteConverti,
            date_envoi: Date.now(),
            sent: true,
            message_logical_id: logicalId
        });
        return 'sent';
    } catch (err) {
        if (err.message?.includes('Aucune one-time key')) {
            socket.emit('e2ee-otk-needed', { target: window.destinataireID, message_logical_id: logicalId });
            popToast('🔄 Synchronisation E2EE en cours — le message partira automatiquement…');
        } else if (err.message?.includes('BAD_ACCOUNT_KEY') || err.message?.includes('OLM.BAD_ACCOUNT_KEY')) {
            console.error('[E2EE] local_pickle/key désynchronisés — déclenchement de la réparation.');
            popToast('🛠️ Tes clés locales sont corrompues. Entre ton PIN pour les réparer.');
            if (typeof window.declencherReparationLocale === 'function') window.declencherReparationLocale();
        } else {
            console.error('[E2EE] Erreur chiffrement :', err.message);
            popToast('⚠️ Chiffrement impossible : ' + err.message);
        }
        return 'error';
    }
}

export async function send() {
    const input = document.getElementById('input');
    if (typeof window._fermerMentionFlyout === 'function') window._fermerMentionFlyout();
    const texteBrut = input ? _getInputText(input).trim() : "";
    if (!texteBrut && !(window.fichiersEnAttente?.length > 0)) return;
    if (!window.monPseudo) return;

    if (texteBrut.toLowerCase() === '/inquisition') {
        if (typeof window.ouvrirModalBootstrap === 'function') window.ouvrirModalBootstrap();
        if (input) _clearInput(input);
        return;
    }

    if (texteBrut.toLowerCase() === '/sondage') {
        if (typeof window.ouvrirModaleSondage === 'function') window.ouvrirModaleSondage();
        if (input) _clearInput(input);
        return;
    }

    const sep = document.getElementById('unread-separator');
    if (sep) sep.remove();

    const texteConverti = typeof window.convertirRaccourcisEnEmojis === 'function' 
        ? window.convertirRaccourcisEnEmojis(texteBrut) 
        : texteBrut;

    if (window.fichiersEnAttente?.length > 0) {
        const fichiers = [...window.fichiersEnAttente];
        // En MP avec E2EE actif : les fichiers passent par le tuyau chiffré
        // (envoyerFichierMPE2EE) au lieu de l'upload en clair. Sinon, chemin
        // public/sphère habituel (envoyerFichierAvecTexte).
        const e2eeFichier = window.destinataireID && window.ChaosMPCrypto
            && await window.ChaosKeystore.getMeta('device_id')
            && typeof window.envoyerFichierMPE2EE === 'function';

        if (e2eeFichier) {
            const nettoyer = () => {
                if (typeof window.annulerFichier === 'function') window.annulerFichier();
                const inp = document.getElementById('input');
                if (inp) _clearInput(inp);
                const counter = document.getElementById('char-counter');
                if (counter) counter.style.display = 'none';
                if (typeof window.annulerReponse === 'function') window.annulerReponse();
                if (typeof window._majSaisie === 'function') window._majSaisie();
            };
            if (fichiers.length > 1) popToast(`Envoi de ${fichiers.length} fichiers…`, 'stream');
            (async () => {
                let ok = 0;
                for (let i = 0; i < fichiers.length; i++) {
                    const res = await window.envoyerFichierMPE2EE(fichiers[i], i === 0 ? texteConverti : '');
                    if (res) ok++;
                }
                nettoyer();
                if (fichiers.length > 1) popToast(`${ok}/${fichiers.length} fichiers envoyés !`, ok === fichiers.length ? 'success' : 'error');
            })();
            return;
        }

        if (typeof window.envoyerFichierAvecTexte === 'function') {
            if (fichiers.length === 1) {
                window.envoyerFichierAvecTexte(fichiers[0], texteConverti);
            } else {
                popToast(`Envoi de ${fichiers.length} fichiers…`, 'stream');
                (async () => {
                    let ok = 0;
                    for (let i = 0; i < fichiers.length; i++) {
                        const res = await window.envoyerFichierAvecTexte(fichiers[i], i === 0 ? texteConverti : '', true);
                        if (res) ok++;
                    }
                    if (typeof window.annulerFichier === 'function') window.annulerFichier();
                    const inp = document.getElementById('input');
                    if (inp) _clearInput(inp);
                    const counter = document.getElementById('char-counter');
                    if (counter) counter.style.display = 'none';
                    if (typeof window.annulerReponse === 'function') window.annulerReponse();
                    if (typeof window._majSaisie === 'function') window._majSaisie();
                    popToast(`${ok}/${fichiers.length} fichiers envoyés !`, ok === fichiers.length ? 'success' : 'error');
                })();
            }
        }
        return;
    }

    const _edition = typeof window.getEditionEnCours === 'function' ? window.getEditionEnCours() : null;
    if (_edition) {
        if (texteConverti !== _edition.texteOriginal) {
            socket.emit('modifier-message', { id: _edition.id, nouveauTexte: texteConverti });
            popToast(t('toast.msg_edited'));
        }
        if (typeof window.annulerEdition === 'function') window.annulerEdition();
        return;
    }

    const messageData = {
        auteur: window.monPseudo,
        texte: texteConverti,
        destinataire: window.destinataireID || "public",
        salon_id: window.salonActuelID,
        salonId: window.salonActuelID,
        replyTo: typeof window.getReponseEnCours === 'function' ? window.getReponseEnCours() : null,
        ..._ephemereApres ? { expire_after: _ephemereApres } : {},
    };

    if (window.destinataireID && window.ChaosMPCrypto && await window.ChaosKeystore.getMeta('device_id')) {
        const r = await envoyerMPE2EE(texteConverti, { replyTo: typeof window.getReponseEnCours === 'function' ? window.getReponseEnCours() : null });
        if (r === 'sent') {
            if (input) _clearInput(input);
            const cc = document.getElementById('char-counter');
            if (cc) cc.style.display = 'none';
            if (typeof window.annulerReponse === 'function') window.annulerReponse();
            if (typeof window._majSaisie === 'function') window._majSaisie();
            desarmerEphemere();
            return;
        }
        if (r === 'error') return;
    }

    socket.emit('chat message', messageData);
    desarmerEphemere();
    if (input) _clearInput(input);
    const cc = document.getElementById('char-counter');
    if (cc) cc.style.display = 'none';
    if (typeof window.annulerReponse === 'function') window.annulerReponse();
    if (typeof window._majSaisie === 'function') window._majSaisie();
}

export function ouvrirModaleWebhooks() {
    const menuSalon = document.getElementById('channel-context-menu');
    if (menuSalon) menuSalon.style.display = 'none';
    _webhookSalonId = window.salonSelectionneId;
    if (!_webhookSalonId) return;
    const nameInput = document.getElementById('webhook-nouveau-nom');
    if (nameInput) nameInput.value = '';
    const listCont = document.getElementById('webhooks-liste-cont');
    if (listCont) listCont.innerHTML = '<p style="color:#8b949e; font-style:italic;">Chargement…</p>';
    const modal = document.getElementById('modal-webhooks');
    if (modal) modal.style.display = 'flex';
    socket.emit('lister-webhooks', { salonId: _webhookSalonId });
}

export function creerWebhook() {
    const champ = document.getElementById('webhook-nouveau-nom');
    const nom = champ ? champ.value.trim() : "";
    if (!_webhookSalonId) return;
    socket.emit('creer-webhook', { salonId: _webhookSalonId, nom: nom || 'Webhook' });
    if (champ) champ.value = '';
}

export function supprimerWebhook(id) {
    socket.emit('supprimer-webhook', { id });
}

function _copierTexteWebhook(val, btn) {
    navigator.clipboard.writeText(val).then(() => {
        if (!btn) return;
        const a = btn.textContent;
        btn.textContent = '✓ Copié';
        setTimeout(() => { btn.textContent = a; }, 1800);
    }).catch(() => {});
}

export function initChatFlowSync() {
    // Synchronise body.input-visible avec la visibilité de la barre d'input
    // pour que le gradient #content-wrapper::after n'apparaisse qu'en mode chat.
    const inputArea = document.querySelector('.input-area');
    if (inputArea) {
        const syncGrad = () =>
            document.body.classList.toggle('input-visible', inputArea.style.display === 'block');
        syncGrad();
        new MutationObserver(syncGrad).observe(inputArea, { attributes: true, attributeFilter: ['style'] });
    }

    const input = document.getElementById('input');
    if (input) {
        input.addEventListener('input', () => {
            const maintenant = Date.now();
            if (!isTyping || (maintenant - lastTypingSent > 1000)) {
                isTyping = true;
                lastTypingSent = maintenant;
                socket.emit('typing', { destinataire: window.destinataireID, salonId: window.salonActuelID });
            }
            clearTimeout(typingTimeout);
            typingTimeout = setTimeout(() => {
                isTyping = false;
                socket.emit('stop-typing', { destinataire: window.destinataireID, salonId: window.salonActuelID });
            }, 2000);
        });

        input.addEventListener('paste', (e) => {
            const items = e.clipboardData?.items;
            if (!items) return;
            for (const item of items) {
                if (item.kind === 'file' && item.type.startsWith('image/')) {
                    e.preventDefault();
                    const file = item.getAsFile();
                    if (file && typeof window.mettreFichierEnAttente === 'function') {
                        window.mettreFichierEnAttente(file);
                    }
                    return;
                }
            }
        });
    }

    socket.on('info-systeme', (info) => {
        const li = document.createElement('li');
        li.className = 'message-system';
        li.style.fontStyle = 'italic';
        li.style.color = '#8b949e';
        li.style.textAlign = 'center';
        li.style.margin = '10px 0';
        li.style.fontSize = '0.9em';
        li.textContent = info;
        
        const msgUl = document.getElementById('messages');
        if (msgUl) {
            msgUl.appendChild(li);
            if (typeof window.scrollToBottom === 'function') window.scrollToBottom();
        }
    });

    socket.on('webhooks-liste', ({ salonId, webhooks } = {}) => {
        if (_webhookSalonId == null || String(salonId) !== String(_webhookSalonId)) return;
        const cont = document.getElementById('webhooks-liste-cont');
        if (!cont) return;
        cont.innerHTML = '';
        if (!Array.isArray(webhooks) || webhooks.length === 0) {
            cont.innerHTML = '<p style="color:#8b949e; font-style:italic;">Aucun webhook. Crée-en un ci-dessus.</p>';
            return;
        }
        webhooks.forEach(w => {
            const url = `${window.location.origin}/api/webhook/${w.token}`;
            const row = document.createElement('div');
            row.style.cssText = 'border:1px solid #30363d; border-radius:8px; padding:10px; background:#0d1117;';
            const head = document.createElement('div');
            head.style.cssText = 'display:flex; align-items:center; justify-content:space-between; gap:10px; margin-bottom:8px;';
            const nom = document.createElement('strong');
            nom.style.color = '#c9d1d9';
            nom.textContent = w.nom;
            const del = document.createElement('button');
            del.className = 'cyber-btn btn-alt';
            del.style.cssText = 'padding:4px 10px; font-size:0.78em; color:var(--theme-danger);';
            del.textContent = '🗑 Supprimer';
            del.onclick = () => supprimerWebhook(w.id);
            head.appendChild(nom);
            head.appendChild(del);

            const urlRow = document.createElement('div');
            urlRow.style.cssText = 'display:flex; gap:6px; align-items:center;';
            const urlInput = document.createElement('input');
            urlInput.type = 'text';
            urlInput.readOnly = true;
            urlInput.value = url;
            urlInput.style.cssText = 'flex:1; min-width:0; background:#161b22; border:1px solid #30363d; color:#8b949e; border-radius:6px; padding:6px 8px; font-size:0.78em;';
            urlInput.onclick = () => urlInput.select();
            const cp = document.createElement('button');
            cp.className = 'cyber-btn btn-alt';
            cp.style.cssText = 'padding:6px 10px; font-size:0.78em; flex-shrink:0;';
            cp.textContent = '📋 Copier';
            cp.onclick = () => _copierTexteWebhook(url, cp);
            urlRow.appendChild(urlInput);
            urlRow.appendChild(cp);

            row.appendChild(head);
            row.appendChild(urlRow);
            cont.appendChild(row);
        });
    });
}